import api from './api/apiClient';
import { resolveAgentName } from '../utils/agentName';

const OPS = '/ops/api/v1';

const normalizeResponse = async (request, transform) => {
    const response = await request;
    return { ...response, data: transform(response.data || {}) };
};

const normalizePerformance = (data) => ({
    ...data,
    agent_performance: (data.agent_performance || []).map((agent) => ({
        ...agent,
        name: resolveAgentName({ ...agent, agent_name: agent.name }),
    })),
});

const normalizeServiceHealth = (data) => ({
    ...data,
    services: (data.services || []).map((service) => ({
        ...service,
        name: resolveAgentName({ ...service, agent_name: service.name }),
    })),
});

const normalizeWorkflows = (data) => ({
    ...data,
    top_tools: (data.top_tools || []).map((agent) => ({
        ...agent,
        name: resolveAgentName({ ...agent, agent_name: agent.name }),
    })),
});

const observabilityService = {
    getSummary: (timeRange, agentId) =>
        api.get(`${OPS}/observability/summary`, { params: { time_range: timeRange, agent_id: agentId } }),

    getPerformance: (timeRange, agentId) => normalizeResponse(
        api.get(`${OPS}/observability/performance`, { params: { time_range: timeRange, agent_id: agentId } }),
        normalizePerformance,
    ),

    getServiceHealth: (timeRange, agentId) => normalizeResponse(
        api.get(`${OPS}/observability/service-health`, { params: { time_range: timeRange, agent_id: agentId } }),
        normalizeServiceHealth,
    ),

    getLlmMetrics: (timeRange, agentId) =>
        api.get(`${OPS}/observability/llm-metrics`, { params: { time_range: timeRange, agent_id: agentId } }),

    getAgenticWorkflows: (timeRange, agentId) => normalizeResponse(
        api.get(`${OPS}/observability/agentic-workflows`, { params: { time_range: timeRange, agent_id: agentId } }),
        normalizeWorkflows,
    ),

    getAnomalyDetection: (timeRange, agentId) =>
        api.get(`${OPS}/observability/anomaly-detection`, { params: { time_range: timeRange, agent_id: agentId } }),

    getTraces: (limit = 10, offset = 0, timeRange, agentId) =>
        api.get(`${OPS}/observability/traces`, { params: { limit, offset, time_range: timeRange, agent_id: agentId } }),

    // Traces ranked by duration (wall clock, first span start to last span end).
    getSlowestTraces: (timeRange, agentId, limit = 8) =>
        api.get(`${OPS}/observability/slowest-traces`, { params: { limit, time_range: timeRange, agent_id: agentId } }),

    getServiceMap: (timeRange) =>
        api.get(`${OPS}/observability/service-map`, { params: { time_range: timeRange } }),

    getModelPricing: () =>
        api.get(`${OPS}/observability/model-pricing`)
};

export default observabilityService;
